import DocViewer from "@cyntler/react-doc-viewer";
import { Card, Col, DatePicker, Drawer, Form, Row } from "antd";
import styled from "styled-components";

export const PreviewDrawer = styled(Drawer)`
  .ant-drawer-body {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 0;
  }
`;

export const FormItem = styled(Form.Item)`
  .ant-form-item-label {
    padding: 0 0 4px;
  }
`;

export const SectionRow = styled(Row)`
  padding: 12px 24px 12px;
`;

export const SectionHeaderItem = styled.h1`
  padding: 12px 8px 4px;
  font-size: 24px;
  display: block;
  width: 100%;
  margin: 4px;
`;

export const FieldsColumn = styled(Col)`
  padding: 8px;
`;

export const FieldsCard = styled(Card)<{ $required?: boolean }>`
  > .ant-card-head {
    background-color: ${({ $required }): string =>
      $required === true ? "#db011c" : "#ffe0e4"};

    .ant-card-head-title {
      color: ${({ $required }): string => ($required === true ? "#FFF" : "#000")};
    }
  }

  min-width: 350px;
  width: 100%;
  height: 100%;

  .ant-form-item-control {
    max-width: 100%;
  }
`;

export const EstimatedLaunchDatePicker = styled(DatePicker)`
  width: 100%;
`;

export const PreviewDocViewer = styled(DocViewer)`
  height: 100%;
`;

export const UploadDragIcon = styled.p.attrs({
  className: "ant-upload-drag-icon",
})``;

export const UploadText = styled.p.attrs({
  className: "ant-upload-text",
})``;
